import { ExportFileColumns } from "../export-file-interface/export-file.interaface";

/** Export format the dashboard requests — the endpoint returns an Excel workbook. */
export const EXPORT_MODULE = 'xlsx';

export class ExportFileModel {

    // Defaults rather than definite assignment: an unset field would be
    // `undefined`, which JSON.stringify drops from the payload entirely, leaving
    // the backend to distinguish "no filter" from "key missing".
    private status: string = '';
    private branch: string = '';
    private agentChannel: string = '';
    private is_offboarded: boolean = false;
    private searchKeyword: string = '';
    private columns: ExportFileColumns[] = [];


    constructor() { }

    // Getters & Setters


    getStatus(): string {
        return this.status;
    }
    setStatus(status: string) {
        this.status = status;
    }


    getBranch(): string {
        return this.branch;
    }
    setBranch(branch: string) {
        this.branch = branch;
    }

    getAgentChannel(): string {
        return this.agentChannel;
    }
    setAgentChannel(agentChannel: string) {
        this.agentChannel = agentChannel;
    }

    getisOffboarded(): boolean {
        return this.is_offboarded;
    }
    setisOffboarded(is_offboarded: boolean) {
        this.is_offboarded = is_offboarded;
    }

    getSearchKeyword(): string {
        return this.searchKeyword;
    }
    setSearchKeyword(searchKeyword: string) {
        this.searchKeyword = searchKeyword;
    }

    getColumns(): ExportFileColumns[] {
        return this.columns;
    }

    setColumns(data: ExportFileColumns[]) {
        this.columns = data;
    }


    toString() {
        return JSON.stringify({
            export_module: EXPORT_MODULE,
            columns: this.getColumns(),
            filters: {
                mn_rep_status: this.getStatus(),
                branch: this.getBranch(),
                agent_channel: this.getAgentChannel(),
                is_offboarded: this.getisOffboarded(),
                search_keyword: this.getSearchKeyword()
            }
        });
    }

}
